import type { CategoryListingsResult } from "@/api/orval/model";
import { PackageType } from "api/types";
import { getListingPdpPath } from "utils/productTypes";

export const getCustomCategoryDestinationUrl = (
  customCategory: CategoryListingsResult,
  hasGiftCards?: boolean,
) => {
  if (customCategory.categoryInclusions.length === 1) {
    const inclusion = customCategory.categoryInclusions[0];
    if (inclusion.membershipId) {
      return getListingPdpPath(inclusion.membershipId, "Membership");
    }
    if (
      inclusion.packageListingId &&
      !(hasGiftCards && inclusion.listingType === PackageType.GiftCard)
    ) {
      switch (inclusion.listingType) {
        case PackageType.Product:
          return getListingPdpPath(inclusion.packageListingId, "Product");
        case PackageType.ProductFromExternalSource:
          return getListingPdpPath(inclusion.packageListingId, "ProductFromExternalSource");
        case PackageType.Service:
          return getListingPdpPath(inclusion.packageListingId, "Treatment");
        case PackageType.GiftCard:
          return getListingPdpPath(inclusion.packageListingId, "GiftCard");
        default:
          throw new Error("Category listing is missing its product type.");
      }
    }
  }
  return `/shop/custom-category/${customCategory.category.id}`;
};
